import { defaultTo, uniq } from 'ramda';
import { IGetPaymentWidgetMethodsResponse } from '../../../../repositories/billing-payments/v1/get-payment-widget-methods';
import { encodePaymentMethodId } from '../../../../utils/paymentMethods';
import { mapMethod } from './mapMethod';
import { IPaymentWidgetMethodResponse } from '../../../../repositories/billing-payments/entities/PaymentWidget/PaymentWidgetMethodResponse';
import { IGetPaymentMethodsResult } from '../types';

export const mapResponse200 = (response: IGetPaymentWidgetMethodsResponse): IGetPaymentMethodsResult => {
  const methodsRaw: Array<IPaymentWidgetMethodResponse> = defaultTo([], response.methods);

  const initial: Pick<IGetPaymentMethodsResult, 'methods' | 'methodIds' | 'paymentProviders'> = {
    methods: {},
    methodIds: [],
    paymentProviders: [],
  };

  const { methods, methodIds, paymentProviders } = methodsRaw.reduce((stash, methodRaw, index) => {
    const method = mapMethod(methodRaw);

    if (!method) {
      return stash;
    }

    const id = encodePaymentMethodId({ type: method.type, index });

    return {
      methods: {
        ...stash.methods,
        [id]: method,
      },
      methodIds: stash.methodIds.concat([id]),
      paymentProviders: stash.paymentProviders.concat([method.paymentProvider]),
    };
  }, initial);

  return {
    methods,
    methodIds,
    selectedMethodId: defaultTo(null, methodIds[0]),
    paymentProviders: uniq(paymentProviders),
  };
};
